module.exports = __webpack_public_path__ + "bc73703051cba1e197bcf6a119ac14a6.svg";